import * as _ from 'lodash'

import { Container, ContainerDataStore } from '@skinsoft/entity/src/container'
import { LocationDataStore, locationSelectors } from '@skinsoft/entity/src/location'
import { ReactiveVue } from '@skinsoft/reactive-vue'
import { EntityFeaturedCard, LocalizedString } from '@skinsoft/ui'
import Component from 'vue-class-component'
import { toFeatured$ } from '../../serializer/featured'
import { Watch } from 'vue-property-decorator'
import { faCircleNotch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { DELETE_CARD } from '@skinsoft/events'
import { containerSelectors } from '@skinsoft/entity/src/container'

@Component({
    components: {
        sEntityFeaturedCard: EntityFeaturedCard,
        sLocalizedString: LocalizedString,
    },
    props: ['featured'],
    template: require('./container-featured-card.html'),
})
export class ContainerFeaturedCard extends ReactiveVue {
    public $containerDataStore: ContainerDataStore
    public $locationDataStore: LocationDataStore
    public serializer = toFeatured$

    private featured: Container
    private locationPath: string = ''
    private futureLocationPath: string = ''

    private isBeingDeleted = false
    private deleting = false

    public checkIcon = faCheck
    public crossIcon = faTimes
    public circleNotchIcon = faCircleNotch

    private mounted() {
        this.futureLocationPath = containerSelectors.futureLocation(this.featured, this.$i18n.locale)
        this.locationPath = containerSelectors.location(this.featured, this.$i18n.locale)
    }

    public deleteContainer() {
        if(this.featured?.id) {
            this.deleting = true
            this.$emit(DELETE_CARD, this.featured.id)
        }
    }

    @Watch('featured')
    onFeaturedChange() {
        this.isBeingDeleted = false
        this.deleting = false
        this.futureLocationPath = containerSelectors.futureLocation(this.featured, this.$i18n.locale)
        this.locationPath = containerSelectors.location(this.featured, this.$i18n.locale)
    }
}
